import HttpService from "../../constant/Api";

const API = "v1/contents";

export const getContentPerCategoryService = (
  params = {
    categoryId: "",
    pageNumber: 0,
    pageSize: 1000,
    sort: "ASC",
    sortKey: "createdDate",
    title: "",
  }
) => {
  return HttpService.get(`${API}`, { params });
};

export const getContentService = (contentId = "") => {
  return HttpService.get(`${API}/${contentId}`);
};

export const getContentCategoryService = (
  params = {
    pageNumber: 0,
    pageSize: 1000,
    sort: "DESC",
    type: "wiki",
    sortKey: "createdDate",
    hasParent: false,
  }
) => {
  return HttpService.get(`${API}/categories`, { params });
};

export const getCategoryService = (categoryId) => {
  const params = {
    pageNumber: 0,
    pageSize: 1000,
    sort: "ASC",
    type: "wiki",
    sortKey: "createdDate",
  };
  return HttpService.get(`${API}/categories/all?parentId=${categoryId}`, {
    params,
  });
};

export const calculateInflationRateService = (
  params = { amount: "", currentYear: "", previousYear: "" }
) => {
  return HttpService.get(`v1/year-inflation-rate/calculate`, { params });
};
